/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { ITumorBoard } from 'app/shared/model/tumor-board.model';
import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { IDoctor } from 'app/shared/model/doctor.model';
import { TumorBoardPatientStatus } from 'app/shared/model/enumerations/tumor-board-patient-status.model';

export interface ITumorBoardPatient {
  id?: string;
  addedAt?: number;
  completedAt?: number | null;
  status?: keyof typeof TumorBoardPatientStatus;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  board?: ITumorBoard | null;
  patient?: IGlucoUser | null;
  addedBy?: IDoctor | null;
  handedOverBy?: IDoctor | null;
}

export const defaultValue: Readonly<ITumorBoardPatient> = {
  active: false,
};
